import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHelp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#4B7EFF"
      d="M12 4.25c4.25 0 7.75 3.5 7.75 7.75 0 4.281-3.5 7.75-7.75 7.75A7.75 7.75 0 0 1 4.25 12c0-4.25 3.469-7.75 7.75-7.75m0 14A6.25 6.25 0 0 0 18.25 12c0-3.437-2.812-6.25-6.25-6.25A6.25 6.25 0 0 0 5.75 12 6.23 6.23 0 0 0 12 18.25m3.344-7.969c0 2.094-2.281 2.125-2.281 2.906v.188a.36.36 0 0 1-.376.375h-1.406a.36.36 0 0 1-.375-.375v-.25c0-1.125.844-1.562 1.469-1.937.563-.313.906-.5.906-.907 0-.562-.687-.906-1.25-.906-.719 0-1.062.344-1.531.938a.39.39 0 0 1-.531.062l-.875-.656a.35.35 0 0 1-.063-.5C9.75 8.125 10.687 7.5 12.156 7.5c1.531 0 3.188 1.219 3.188 2.781M13.313 15.5A1.3 1.3 0 0 1 12 16.813c-.75 0-1.312-.563-1.312-1.313A1.3 1.3 0 0 1 12 14.188a1.32 1.32 0 0 1 1.313 1.312"
    />
  </svg>
);
export default SvgHelp;
